import { useMediaQuery } from "./use-media-query";
import { BREAKPOINTS } from "./breakpoints";

/**
 * Hook that detects if the viewport is mobile-sized (< 768px).
 * @returns boolean indicating if the current viewport is mobile
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.md - 1}px)`);
}
